import Honeybadger from '@honeybadger-io/js';
import TafkanError from './TafkanError';
Honeybadger.configure({
    apiKey: tfk.honeybadger_api_key,
    environment: tfk.env,
    developmentEnvironments: ['local'],
    revision: 'perpetual_beta',
}).beforeNotify(function (notice) {
    if (notice) {
        // Ensure that we always have user context
        notice.context = {
            ...notice.context,
            user_ip: tfk.user.ipAddress || 'unknown',
            user_id: tfk.user.userID || 'unknown',
        };
        // Tag the notice as a client-side error
        notice.tags = notice.tags || [];
        if (Array.isArray(notice.tags)) {
            notice.tags.push('Javascript');
        }
        else {
            notice.tags += ', Javascript';
        }
    }
});
window.hb = Honeybadger;
/**
 * Logs an error to Honeybadger with structured context.
 * @param {LogErrorParams} params - The parameters for the error.
 */
window.logError = function ({ name, message, cause, context }) {
    window.hb.notify(new TafkanError({
        name,
        message,
        cause,
        context,
    }));
};
